
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TiktokSpecialPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiktokSpecialPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pk"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"caption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"influencer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followersCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detailedReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warningReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"likes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shares"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boostedInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountSystemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adCampaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adGroupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"landingUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authPostCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"draftBoostedInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountSystemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adCampaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adGroupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"landingUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authPostCode"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":618}};
    doc.loc.source = {"body":"query TiktokSpecialPost($pk: Int!) {\n  tiktokSpecialPost(pk: $pk) {\n    id\n    postUrl\n    caption\n    influencer {\n      id\n      name\n      avatar\n      followersCount\n    }\n    images\n    status\n    reason\n    detailedReason\n    warningReason\n    postedDate\n    likes\n    views\n    comments\n    shares\n    boostedInfo {\n      adAccountSystemId\n      adCampaignId\n      adGroupId\n      adName\n      callToAction\n      landingUrl\n      authPostCode\n    }\n    draftBoostedInfo {\n      adAccountSystemId\n      adCampaignId\n      adGroupId\n      adName\n      callToAction\n      landingUrl\n      authPostCode\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TiktokSpecialPost"] = oneQuery(doc, "TiktokSpecialPost");
        
